namespace GeniuzPOS.Lookups {
    export interface VwCashierRow {
        Id?: number;
        CashierId?: string;
        CashierName?: string;
        FullName?: string;
    }

    export namespace VwCashierRow {
        export const idProperty = 'CashierId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Lookups.VwCashier';
        export const lookupKey = 'VwCashierRow';

        export function getLookup(): Q.Lookup<VwCashierRow> {
            return Q.getLookup<VwCashierRow>('VwCashierRow');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            CashierId = "CashierId",
            CashierName = "CashierName",
            FullName = "FullName"
        }
    }
}
